// TODO: Feature flags remaining work
//  SWJ (not implemented)
//     - swj_module
//     - swj_tickers_and_borders
//     - double_your_bet
//  BRAZE (not implemented)
export const PRODUCT_THROTTLES = {
    FAVOURITE_GAMES: 'has_favourite_games_icon',
    NUMBER_OF_TICKETS: 'has_number_of_tickets',
    HIDE_ELIGIBLE_GAMES: 'has_eligible_games_hidden',
    BRAZE_INBOX: 'has_braze_inbox',
    DAILY_JACKPOTS: 'has_jackpots',
    PROGRESSIVE_JACKPOTS: 'has_fgp_jackpots',
    REWARDS_MACHINE: 'has_rewards_machine',
    BONUS_SPINS: 'has_bonus_spins',
    SWJ_MODULE: 'swj_module',
    HAS_ACCOUNT_REWARDS: 'has_account_rewards',
    SWJ_TICKERS_AND_BORDERS: 'swj_tickers_and_borders',
    BECAUSE_YOU_PLAYED: 'has_because_you_played',
    SWJ_DOUBLE_YOUR_BET: 'double_your_bet',
    HAS_PROMO_BUTTON: 'has_promo_button',
    USE_LEGACY_RM: 'use_legacy_rm',
    HAS_NEW_GAME_LABELS: 'has_new_game_labels',
    HAS_NEW_GRID_LAYOUT: 'has_new_grid_layout',
    CATEGORY_V2_LAYOUT: 'has_category_v2',
    CATEGORY_V3_LAYOUT: 'has_category_v3',
    HAS_EARLY_ACCESS: 'has_early_access',
    HAS_USER_PROFILE_WEB: 'has_user_profile_web',
    HAS_PUBLIC_USER_PROFILE_WEB: 'has_public_user_profile_web',
    HAS_ANIMATED_TILES: 'has_animated_tiles',
    USE_XP: 'use_xp',
    HAS_LOYALTY_CHALLENGES: 'has_loyalty_challenges'
};

export const GENEROSITY_MODULES = {
    BONUS_SPINS: 'bonus_spins',
    REWARD_BOXES: 'reward_boxes',
    PRIMARY_PERK_V2: 'primary_perk_v2',
    BONUS_CASH_WALLETS: 'bonus_cash_wallets',
    CHALLENGES: 'challenges',
    PROMO_FEED: 'promo_feed'
} as const;
